import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  findAllUsersPageble,
  updateUser,
  deleteUser,
  deactivateUser,
  activateUser,
  deleteErrorUser,
  createUserProtenant,
  findAllUserFilterPageable,
} from '../../actions/user';
import { findAllRolesHashMapList } from '../../actions/role';
import PropTypes from 'prop-types';
import UserTable from './UserTable';
import withTranslations from '../../utils/HighOrderComponent';
import { TablePagination } from '@material-ui/core';
import LoadingIndicator from '../Reusable/LoadingIndicator';
import {
  numberOfItemsPerPage,
  rowsPerPageOptions,
  userRoles,
} from '../../constants/globals.js';
import { changePaginationTextToSerbian, checkForUserRole } from '../../utils';
import {
  findAllPlaceByAutonomousProvince,
  findAllPlaceWithoutAutonomousProvince,
  clearPlaceList,
  findAllPlace,
} from '../../actions/place';
import {
  findAllMunicipalityByPlace,
  clearMunicipalityList,
} from '../../actions/municipality';
import { findAllInstitutionType } from '../../actions/institutionType';
import {
  findAllKjsByInstitutionType,
  clearKjsList,
  findAllKjs,
  findAllKjsFilterPageable,
} from '../../actions/kjs';

class UserList extends Component {
  constructor() {
    super();
    this.state = {
      activePage: 0,
      numberOfItemsPerPage: numberOfItemsPerPage,
    };
  }
  componentDidMount() {
    this.props.findAllUsersPageble(0, this.state.numberOfItemsPerPage);
    this.props.findAllRolesHashMapList();
    this.props.findAllPlace();
    this.props.findAllInstitutionType();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.resetData) {
      const postData = {
        tableName: 'user',
        filterCriteria: [{ returnAllSignal: true }],
      };
      this.props.findAllUserFilterPageable(
        0,
        this.state.numberOfItemsPerPage,
        postData
      );
      nextProps.setResetData(false);
    }
  }

  handlePreviewClose = () => {
    this.props.deleteErrorPhysicalEntity();
  };

  handlePageChange = (event, value) => {
    this.setState({
      activePage: value,
    });
    this.props.postData
      ? this.props.findAllUserFilterPageable(
          value,
          this.state.numberOfItemsPerPage,
          this.props.postData
        )
      : this.props.findAllUsersPageble(value, this.state.numberOfItemsPerPage);
  };

  handleChangeRowsPerPage = (event, value) => {
    this.props.postData
      ? this.props.findAllUserFilterPageable(
          0,
          event.target.value,
          this.props.postData
        )
      : this.props.findAllUsersPageble(0, event.target.value);

    this.setState({
      numberOfItemsPerPage: event.target.value,
      activePage: 0,
    });
  };

  render() {
    const { isLoadingNeeded, user, role, loggedUser } = this.props || {},
      { userList, error, totalElements } = user || {},
      { rolesHashMapList } = role || {},
      { roles } = loggedUser;

    if (isLoadingNeeded) {
      return <LoadingIndicator />;
    }

    let rolesHashMapListFiltered = rolesHashMapList;

    if (!checkForUserRole(roles, userRoles.SUPER_ADMIN.value)) {
      rolesHashMapListFiltered = rolesHashMapList.filter(
        (role) => role.roleName !== userRoles.SUPER_ADMIN.text
      );
      if (checkForUserRole(roles, userRoles.ADMIN_MDULS.value)) {
        rolesHashMapListFiltered = rolesHashMapListFiltered.filter(
          (role) =>
            role.roleName !== userRoles.ADMIN_EU.text &&
            role.roleName !== userRoles.ADMIN_MDULS.text
        );
      }
    }

    return (
      <Fragment>
        <UserTable
          userList={userList}
          rolesHashMapList={rolesHashMapListFiltered}
          deleteUser={this.props.deleteUser}
          updateUser={this.props.updateUser}
          deactivateUser={this.props.deactivateUser}
          activateUser={this.props.activateUser}
          createUserProtenant={this.props.createUserProtenant}
          error={error}
          deleteError={this.props.deleteErrorUser}
          autonomousProvinceList={this.props.autonomousProvinceList}
          placeList={this.props.placeList}
          municipalityList={this.props.municipalityList}
          kjsList={this.props.kjsList}
          institutionTypeList={this.props.institutionTypeList}
          findAllPlaceByAutonomousProvince={
            this.props.findAllPlaceByAutonomousProvince
          }
          findAllMunicipalityByPlace={this.props.findAllMunicipalityByPlace}
          findAllKjsByInstitutionType={this.props.findAllKjsByInstitutionType}
          findAllPlaceWithoutAutonomousProvince={
            this.props.findAllPlaceWithoutAutonomousProvince
          }
          clearPlaceList={this.props.clearPlaceList}
          clearMunicipalityList={this.props.clearMunicipalityList}
          clearKjsList={this.props.clearKjsList}
          findAllPlace={this.props.findAllPlace}
          findAllKjs={this.props.findAllKjs}
          findAllKjsFilterPageable={this.props.findAllKjsFilterPageable}
        />
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <TablePagination
            component="div"
            count={Number(totalElements)}
            page={this.state.activePage}
            onPageChange={this.handlePageChange.bind(this)}
            rowsPerPageOptions={rowsPerPageOptions}
            onRowsPerPageChange={this.handleChangeRowsPerPage.bind(this)}
            rowsPerPage={this.state.numberOfItemsPerPage}
            labelRowsPerPage={this.props.t.rowPerPage}
            labelDisplayedRows={(obj) =>
              changePaginationTextToSerbian(obj, this.props.t.of)
            }
          />
        </div>
      </Fragment>
    );
  }
}

UserList.propTypes = {
  user: PropTypes.object.isRequired,
  findAllUsersPageble: PropTypes.func.isRequired,
  createUserProtenant: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
  role: state.role,
  isLoadingNeeded: state.user.loading,
  autonomousProvinceList: state.autonomousProvince.autonomousProvinceList || [],
  placeList: state.place.placeList || [],
  municipalityList: state.municipality.municipalityList || [],
  kjsList: state.kjs.kjsList || [],
  institutionTypeList: state.institutionType.institutionTypeList || [],
  loggedUser: state.loggedUser.loggedUser || {},
});

const mapDispatchToProps = (dispatch) => {
  return {
    findAllUsersPageble: (pageNumber, pageSize) => {
      dispatch(findAllUsersPageble(pageNumber, pageSize));
    },
    updateUser: (user, callback, messages) => {
      dispatch(updateUser(user, callback, messages));
    },
    deleteUser: (id) => {
      dispatch(deleteUser(id));
    },
    deactivateUser: (id) => {
      dispatch(deactivateUser(id));
    },
    activateUser: (id) => {
      dispatch(activateUser(id));
    },
    deleteErrorUser: () => {
      dispatch(deleteErrorUser());
    },
    findAllRolesHashMapList: () => {
      dispatch(findAllRolesHashMapList());
    },
    findAllPlaceWithoutAutonomousProvince: () => {
      dispatch(findAllPlaceWithoutAutonomousProvince());
    },
    findAllPlaceByAutonomousProvince: (autonomousProvinceId) => {
      dispatch(findAllPlaceByAutonomousProvince(autonomousProvinceId));
    },
    findAllMunicipalityByPlace: (placeId) => {
      dispatch(findAllMunicipalityByPlace(placeId));
    },
    findAllInstitutionType: () => {
      dispatch(findAllInstitutionType());
    },
    findAllKjsByInstitutionType: (institutionTypeId) => {
      dispatch(findAllKjsByInstitutionType(institutionTypeId));
    },
    findAllKjs: () => {
      dispatch(findAllKjs());
    },
    clearPlaceList: () => {
      dispatch(clearPlaceList());
    },
    clearMunicipalityList: () => {
      dispatch(clearMunicipalityList());
    },
    clearKjsList: () => {
      dispatch(clearKjsList());
    },
    findAllPlace: () => {
      dispatch(findAllPlace());
    },
    createUserProtenant: (user, callback, message) => {
      dispatch(createUserProtenant(user, callback, message));
    },
    findAllKjsFilterPageable: (pageNumber, pageSize, data, succesCallback) => {
      dispatch(
        findAllKjsFilterPageable(pageNumber, pageSize, data, succesCallback)
      );
    },
    findAllUserFilterPageable: (
      pageNumber,
      pageSize,
      postData,
      successCallback
    ) => {
      dispatch(
        findAllUserFilterPageable(
          pageNumber,
          pageSize,
          postData,
          successCallback
        )
      );
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslations(UserList, 'UserList'));
